import { FormBuilder, Validators } from '@angular/forms';
import { HelpersService } from '../../core/services/helpers.service';
import { OperationsService } from '../../core/services/operations.service';
import {
  DefinisciFascicoloAdapter
} from '../components/option-component/definisciFascicolo/definisci-fascicolo-adapter';
import { DefinisciFascicoloRequest } from '../models/dto/definisci-fascicolo-request';
import { Fascicolo } from '../models/fascicolo/fascicolo';
import { StatoEntita } from '../models/tipologiche/stato-entita';
import { BaseForm } from './base-Form';

declare var removeEmptyObject: any;
export abstract class DefinisciFascicoloForm extends BaseForm {
  request: DefinisciFascicoloRequest;
  definisciFascicoloForm: any;
  motiviDefinizione: StatoEntita[] = [];
  motivoDefinizione: StatoEntita;
  today:Date = new Date();

  constructor(protected operationService: OperationsService, private campiForm: FormBuilder, protected helpers: HelpersService) {
    super();
  }

  createForm(fascicolo: Fascicolo) {
    this.request = new DefinisciFascicoloAdapter(fascicolo).definisciFascicoloRequest;
    this.motivoDefinizione = new StatoEntita();
    if (this.request.idMotivoDefinizione) {
      this.motivoDefinizione.id = this.request.idMotivoDefinizione;
    }else {
      this.motivoDefinizione = null;
    }
    this.definisciFascicoloForm = this.campiForm.group({
      dataDefinizione: [this.request.dataDefinizione, Validators.required],
      motivoDefinizione: [this.request.idMotivoDefinizione, Validators.required],
    });
  }

  update() {
    this.request.idMotivoDefinizione = this.motivoDefinizione.id;
    this.getRequest(this.request);
  }

  populateSelect() {
    if (this.motiviDefinizione.length === 0) {
      this.helpers.getMotiviDefinizione().subscribe(response => this.motiviDefinizione = response);
    }
  }

  abstract getFascicolo(): Fascicolo;
  abstract getRequest(request: DefinisciFascicoloRequest);

}
